import { OT_ERRORS } from '../errors-types';
import * as devices from '../../../../../modules/devices';
import { PublisherErrorHandler } from '../publisher-error-handler';
import { AngularServices } from '../../../../../modules/core';
export default class OtHardwareUnavailableErrorHandler extends PublisherErrorHandler {
    constructor() {
        super(...arguments);
        this.errorName = OT_ERRORS.HARDWARE_UNAVAILABLE;
        this.tiedDeviceIds = [];
    }
    get redux() {
        return this.$injector.get(AngularServices.Redux);
    }
    get activeProvider() {
        return this.$injector.get(AngularServices.VideoProviderFactory)
            .activeProvider;
    }
    onError(err) {
        this.debug('onError', err);
        this.handleFix();
    }
    handleFix() {
        const accessibleCameras = devices.selectors.getAccessibleCameras(this.redux.getState());
        const nextCameraToTry = accessibleCameras.find((camera) => !this.tiedDeviceIds.includes(camera.deviceId));
        this.debug('handleFix:nextCameraIdToTry', nextCameraToTry);
        if (Boolean(nextCameraToTry)) {
            this.isFixApplied = true;
            this.tiedDeviceIds.push(nextCameraToTry.deviceId);
            this.redux.dispatch(devices.actions.changeVideoDevice(nextCameraToTry.deviceId));
            void this.activeProvider.enableWebcam();
        }
        else {
            this.notify({ isFixed: false });
        }
    }
}
